import { storeGift } from "@/stores/gift.js";
import $axios from "@/axios";

export default {
  //請求分類
  get: async function () {
    await $axios
      .post("/api/admin/gift_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeGift.gifts = res.data.gifts;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
